import {constructUrl, HttpClient} from '../helper/HttpClient';
import {Employee} from '../models/Employee.model';

export async function search(searchValue: string): Promise<Employee[]> {
    const filterCondition = `?searchValue=${searchValue}`;
    return await new HttpClient().get(constructUrl('employees') + filterCondition);
}